// src/helpers/gtagHelper.js
// Helper for Google Analytics gtag event tracking with order object

/**
 * Send a gtag event for an order.
 * @param {string} eventName - The gtag event name (e.g. 'begin_checkout').
 * @param {Object} order - The order object from backend.
 */
export function gtagOrderEvent(eventName, order) {
  if (!window.gtag || !order) return;
  const items = order.orderLines?.edges?.map(({ node }) => {
    const item = {
      item_id: node.productId,
      item_name: node.name,
      price: Number(node.price),
    };
    if (typeof node.quantity !== 'undefined') {
      item.quantity = node.quantity;
    }
    return item;
  });
  const gtagData = {
    transaction_id: order.id,
    value: Number(order.totalPrice - order.totalTax),
    tax: Number(order.totalTax),
    coupon: order.orderCoupon?.code || undefined,
    currency: order.currency?._id,
    items,
  };
  window.gtag('event', eventName, gtagData);
}

/**
 * Send a gtag event for adding a book to cart.
 * @param {Object} book - The book object being added to cart.
 */
export function gtagAddToCartEvent(book) {
  if (!window.gtag || !book) return;
  const price = book?.price || 0;
  const currency = book?.currency?._id;
  const gtagData = {
    currency: currency,
    items: [
      {
        item_id: book?.id || book?._id,
        item_name: book?.title,
        price: Number(price),
        quantity: 1,
      },
    ],
  };
  window.gtag('event', 'add_to_cart', gtagData);
}
